import authRules from '../authRules.js';

const resourceInfo = (user) => {
  const { resourceInfo } = user.securityLevels;
  if (resourceInfo >= authRules.resourceInfo.resourceInfo) {
    return true;
  } else {
    return false;
  }
}

export default resourceInfo;
